<template>
<div class="folder">
   
    <div class="box"  >
        <div style="display: flex;align-items: center;">
        <el-button  icon="el-icon-document-add" type="primary" plain @click="dialog = true" style="margin-right:20px" >本地上传</el-button>
        <el-dialog
            title="上传文件"
            :visible.sync="dialog"
            width="30%"
            center>
          <div  style="text-align: center;">
            <el-upload
                class="upload-demo"
                accept=".pdf,.zip"
                action="#"
                style="margin-bottom:20px"
                drag
                :limit='1' 
                ref="upload"
                :show-file-list="true"
                :auto-upload="false"
                :on-change="upload"
                :file-list="fileList"
                :on-remove="remove"
                :on-exceed="exceed"
                multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传pdf/zip文件</div>
            </el-upload>
          </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialog = false">取 消</el-button>
                <el-button type="primary" @click="uploadFile">确定上传</el-button>
            </span>
            </el-dialog>
         <el-button @click="download" type="warning" plain icon="el-icon-bottom">导出</el-button>
        <el-dialog
            title="导出文档"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
          
         <div class="flagBox">
            <div class="flagType">
                 <div> <img src="../../assets/img/word.png" alt=""> </div>
                 <div style="margin-left:10px;margin-right:20px">Word</div>
            </div>
            <div style="margin-bottom:20px">
                <el-radio v-model="listQuery.flag" label="1">单语</el-radio>
                <el-radio v-model="listQuery.flag" label="2">双语</el-radio>
            </div>
           
         </div>
            <span slot="footer" class="dialog-footer">
                <el-button class="typeButton" @click="downFolder">导出</el-button>
            </span>
            </el-dialog>
        </div>
        <div class="table-box">
                <div style="display:flex;align-items:center;padding: 30px 30px 15px 30px;justify-content: space-between;">
                    <h2>文件管理</h2>
                    <div>
                        <el-date-picker
                            v-model="selDateTimes"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            :default-time="['00:00:00', '23:59:59']"
                            size="small"
                            @change="setTime"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
                <div>
                    <el-table
                        v-loading="loading" element-loading-text="加载中"
                        ref="multipleTable"
                        :header-cell-style="{background:'#EEECED',color:'#606266'}"
                        :data="folderList"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                        @sort-change="orderBy">
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column
                        sortable="custom" prop="create_time" :sort-orders="['ascending', 'descending',null]"
                        label="创建时间">
                            <template slot-scope="scope">
                                <span>{{ scope.row.create_time }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                        label="文件名"
                        >
                        <template slot-scope="scope">
                                <span>{{ scope.row.file_name }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column
                        label="文件状态"
                        >
                        <template slot-scope="scope">
                                <span>{{ scope.row.state }}</span>
                        </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width">
                            <template slot-scope="{row}">
                             <el-popconfirm
                                confirm-button-text='确认'
                                cancel-button-text='取消'
                                icon="el-icon-info"
                                icon-color="red"
                                title="确认删除此文件吗？"
                               
                                @confirm="delOrgUser(row)"
                                >
                                <el-button type="danger"  slot="reference">删除</el-button>
                            </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="page" style="margin-top:20px">
                       <el-pagination
                        style="text-align: right;"
                        background
                        layout="total,sizes,prev, pager, next,jumper"
                        :total="total"
                        :page-sizes="[10,20,50]"
                        :page-size="listQuery.size"
                        @size-change="handleSizeChange"
                        :current-page.sync="listQuery.page"
                        @current-change="handleCurrentChange"
                    ></el-pagination>
                    </div>
                </div>
            </div>

    </div>
    

</div>

</template>

<script>
import * as echarts from 'echarts';

export default {
    name:"",
    data(){
        return{
        dialog:false,
        selDateTimes:[],
        centerDialogVisible:false,
        folder_id:this.$route.query.folder_id,
        dialogVisible: false,
        form:{
            update_password:"",
            password:""
        },
        rules:{
            password: [{required: true,message: '请输入原密码',type: 'error'}],
            update_password: [{required: true,message: '请输入修改之后的密码',type: 'error'}],
        },
        showSearch:false,
        indexShow:1,
        SubList: 'site_user',
        folderList:[],
        loading:false,
        historicalList:[],
        loadingList:false,
        input:"",
        listQuery:{
            page:1,
            size:10,
            flag:null, // 1 单语 2 双语
            create_time:"",//开始时间
            end_time:"",//结束时间
            order:""//正降序排序
        },
        total:0,
        is_tran:"1",//默认0不翻译 1翻译
        fileList:[],
        orgname:localStorage.getItem("organ_name"),
        surplus:0,//剩余
        used_num:0,//已使用
        historQuery:{
            page:1,
            size:10,
        },
        count:0,
        }
    },
    created(){
            console.log(this.folder_id)
            this.folderInfo() // 获取文件夹下的所有文件
            this.historicalInfo() // 个人历史记录
    },
    mounted(){
        // this.initChart()
    },
    watch:{
        $route(to,form){
            this.folder_id = to.query.folder_id
             this.folderInfo() // 获取文件夹下的所有文件
        }
    },
    methods: {
        exceed(file,fileList){
            if(fileList.length == 1){
                this.$message.error("上传多个文件,需上传压缩包")
            }
        },
        remove(file,fileList){
            this.fileList = []
        },
        // 删除历史记录
        delFile(row){
            var list = []
            list.push(row.pdf_md5)
            this.$http({
                url:"api/del_historical/",
                method:"GET",
                params:{
                    pdf_md5:JSON.stringify(list)
                }

            }).then(res=>{
                if(res.data.code = 200){
                    this.$message.success(res.data.message)
                    this.historicalInfo()
                }else{
                    this.$message.error(res.data.message)
                    this.historicalInfo()
                }
            })
        },
        // 历史记录下载文件
        down(row){
            if(row.down_link === "文件过期，仅保存七天内文件"){
                this.$message.error("文件过期，仅保存七天内文件")
            }else{
                window.location.href = row.down_link
            }
        },
        // 返回上一页
        backnext(){
            this.$router.push({
                path:"/user",
            });
        },
       
      
        showImg (index) {
            this.SubList = index
            this.showSearch = ! this.showSearch;
        },
        
        // 获取文件夹下的所有文件
        folderInfo(){
            this.loading = true
            this.$http({
                url:"api/get_folder_filename/",
                method: 'GET',
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                    page:this.listQuery.page,
                    size:this.listQuery.size,
                    folder_id:this.folder_id,
                    organ_name:localStorage.getItem("organ_name"),
                    create_time:this.listQuery.create_time,
                    end_time:this.listQuery.end_time,
                    order:this.listQuery.order
                }
            }).then(res=>{
                this.loading = false
                // console.log(res)
                this.folderList = res.data.data.data
                this.total = res.data.data.total
            })
        },
        // 分页
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.folderInfo();
        },
        handleSizeChange(val){
            this.listQuery.size = val
            this.folderInfo();
        },
        handleCChange(val) {
            this.historQuery.page = val;
            this.historicalInfo();
        },
        handleSChange(val){
            this.historQuery.size = val
            this.historicalInfo();
        },
        
         // 日期选择器 获取开始日期start_date 结束日期end_date 
        setTime(e){
            // console.log(e)
            if(e == null){
                this.listQuery.create_time = ""
                this.listQuery.end_time = ""
                this.search()
            }else{
                this.listQuery.create_time = e[0]
                this.listQuery.end_time = e[1]
                this.search()
            }
            
            
        },
        search(){
            this.folderInfo();
        },
        //退出登录
        exit(){
            this.$confirm('是否退出登录?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '已退出登录!'
                });
                localStorage.removeItem("token")
                this.$router.push({
                    name: "login",
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出登录'
                });          
            });
        },
         // 更改联系日期排序
        orderBy(column, prop, order){
            // 联系日期排序
            if (column.prop == "create_time"){
                if(column.order == "ascending"){
                    this.listQuery.order = "asc"
                }else if(column.order == "descending"){
                    this.listQuery.order = ""
                }else{
                    this.listQuery.order = null
                }
            }
            this.search()
        },
        // 获取历史记录查询列表
        historicalInfo(){
            this.loadingList = true
            this.$http({
                url:"api/get_historical_records/",
                method:"GET",
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                params:{
                    page:this.historQuery.page,
                    size:this.historQuery.size,
                    organ_name:localStorage.getItem("organ_name"),
                }
            }).then(res=>{
                this.loadingList = false
                this.historicalList = res.data.data.data
                this.count = res.data.data.total
                // console.log(this.historicalList)
            })
        },
        upload(file,fileList){
            // console.log(file)
            this.fileList = fileList[0].raw
            console.log(this.fileList)
        },
        // 上传文件
        uploadFile () {
            if(this.fileList.length == 0){
                this.$message.error("请选择上传文件")
            }else{
                this.$http({
          url: 'api/input_file/', //后端提供的接口
          method: 'post',
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          data: {
              input_file:this.fileList,
              organ_name:localStorage.getItem("organ_name"),
              is_tran:this.is_tran,
              folder_id:this.folder_id
          },
          
        }).then(res=>{
           if(res.data.code == 200){
               this.$message.success("上传成功");
               this.$refs.upload.clearFiles()
               this.dialog = false
               this.folderInfo()
               this.historicalInfo()
               
           }else{
               this.$message.error(res.data.message);
               this.$refs.upload.clearFiles()
               this.dialog = false
               this.historicalInfo()
           }
        })
            }
            console.log(this.fileList)
        
    },
        // 修改账号信息
        OrgaddUser(){
            this.$http({
                url:"api/user_core/",
                method:"POST",
                data:{
                    organ_name:localStorage.getItem("organ_name"),
                    password:this.form.password,
                    update_password:this.form.update_password
                }
            }).then(res=>{
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }else{
                    this.$message.error(res.data.message);
                    this.dialogVisible = false
                    this.form.update_password=""
                    this.form.password=""
                }
            })
        },
        handleSelectionChange(val) {
        this.multipleSelection = val;
    },
    // 导出文件
    download(){
        if(this.multipleSelection == undefined || this.multipleSelection.length == 0){
            this.$message.error('请选择要导出的文件！！！');
        }else{
            this.centerDialogVisible = true
        }
    },
    downFolder(){
         var id = []
            if(this.listQuery.flag == null){
                this.$message({
                    message: "请选择导出版本",
                    type: 'error'
                });
            }else{
               
            this.multipleSelection.forEach(item => {
                id.push(item.pdf_md5)
            });
           var task_id = id
                this.$http({
                    url:"api/download",
                    method:"GET",
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    params:{
                        flag:this.listQuery.flag,
                        task_id:JSON.stringify(task_id),
                        organ_name:localStorage.getItem("organ_name"),
                    }
                }).then(res=>{
                    if(task_id.length == 1){
                        if(res.data.code = 200){
                            this.$refs.multipleTable.clearSelection();
                            this.$message.success(res.data.message)
                            this.centerDialogVisible = false
                            window.location.href = res.data.data.link
                        }else{
                            this.$refs.multipleTable.clearSelection();
                            this.$message.error(res.data.message)
                            this.centerDialogVisible = false
                        }
                    }else{
                        if(res.data.code = 200){
                            this.$refs.multipleTable.clearSelection();
                            this.$message.success(res.data.message)
                            this.centerDialogVisible = false
                            var array = res.data.data
                            for (let i = 0; i < array.length; i++) {
                                const iframe = document.createElement("iframe");
                                iframe.style.display = "none"; // 防止影响页面
                                iframe.style.height = 0; // 防止影响页面
                                iframe.src = array[i].link; 
                                document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
                                // 5分钟之后删除（onload方法对于下载链接不起作用）
                                setTimeout(()=>{
                                    iframe.remove();
                                }, 5 * 60 * 1000)

                                // var element = array[i];
                                // window.location.href = element.link  
                               
                            }
                        }else{
                            this.$refs.multipleTable.clearSelection();
                            this.$message.error(res.data.message)
                            this.centerDialogVisible = false
                        }
                    }
                    
                })
            }
    },
    delOrgUser(row){
        var userId = []
        userId.push(row.id)
        this.$http({
                url:"api/user_del_file/",
                method:"POST",
                data:{
                    id:userId,
                    organ_name:localStorage.getItem("organ_name"),
                }
            }).then(res=>{
                this.$message({
                    message: res.data.message,
                    type: 'success'
                });
                this.folderInfo()
            }).catch(err=>{
                this.$message({
                    message: res.data.message,
                    type: 'warning'
                });
                this.folderInfo()
            })
    }
    },

}
</script>
<style lang="scss">
.t-layout__content {
    flex: auto;
    // height: calc(100vh - 190px); 1000px
    min-height: 1000px;
    background-color: white;
    margin: 20px;
    // margin: 10px 0px 20px 20px;
}
.t-default-menu .t-menu__item.t-is-active:not(.t-is-opened) {
    // #6B29BE #F2E9FA
    color: #fff;
    background-color: #7d21cd;
}
.t-layout__footer {
    color: var(--td-text-color-placeholder);
    // background-color: white;
    // padding: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
     .left {
            width: 250px;
            margin-right: 30px;
            text-align: left;
            color: #b0b0b0;
            list-style: none;
        }
        .right{
            text-align: left;
            border-left: 2px solid #b0b0b0;
            padding-left: 30px;
            color: #b0b0b0;
            list-style: none;
        }
}
.el-radio__inner {
    border: 1px solid #DCDFE6;
    /* border-radius: 100%; */
    width: 14px;
    height: 14px;
    background-color: #FFF;
    cursor: pointer;
    box-sizing: border-box;
}
</style>
<style lang="scss" scoped>
.row:after {
    content: "";
    clear: both;
    display: block;
}

/* For mobile phones: */
[class*="col-"] {
    width: 100%;
}
@media only screen and (min-width: 600px) {
    /* For tablets: 8.33 */
    .col-m-1 {width: 8.33%;}
    .col-m-2 {width: 16.66%;}
    .col-m-3 {width: 25%;}
    .col-m-4 {width: 33.33%;}
    .col-m-5 {width: 41.66%;}
    .col-m-6 {width: 50%;}
    .col-m-7 {width: 58.33%;}
    .col-m-8 {width: 66.66%;}
    .col-m-9 {width: 85%;}
    .col-m-10 {width: 83.33%;}
    .col-m-11 {width: 91.66%;}
    .col-m-12 {width: 100%;}
}
@media only screen and (min-width: 768px) {
    /* For desktop: */
    .col-1 {width: 8.33%;}
    .col-2 {width: 16.66%;}
    .col-3 {width: 25%;}
    .col-4 {width: 33.33%;}
    .col-5 {width: 41.66%;}
    .col-6 {width: 50%;}
    .col-7 {width: 58.33%;}
    .col-8 {width: 66.66%;}
    .col-9 {width: 75%;}
    .col-10 {width: 83.33%;}
    .col-11 {width: 91.66%;}
    .col-12 {width: 100%;}
}
.el-icon-arrow-left:before {
    content: "\e6de";
    color: #706e6e;
    font-size: 22px;
    font-weight: 700;
}
::v-deep .el-table {
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
    flex: 1;
    width: 100%;
    max-width: 100%;
    font-size: 14px;
    color: #606266;
    border-radius: 15px;
}
::v-deep .el-button--danger {
    color: #FFF;
    background-color: #F56C6C;
    border-color: #F56C6C;
    border-radius: 20px;
    height: 25px;
    line-height: 3px;
}
.typeButton{
    background: linear-gradient(to bottom right,#9B2CF2,#3B49F8);
    color: white;
    height: 33px;
    line-height: 5px;
    padding: 0px 75px;
    border-radius: 10px;
}
.flagBox{
    display: flex;
    align-items: end;
}
.flagType{
    width: 50%;
    height: 52px;
    line-height: 52px;
    display: flex;
    align-items: center;
    box-shadow: 1px 1px 20px 1px rgb(213, 208, 208);
    margin: 0px 20px;
    border-radius: 10px;
    justify-content: space-around;
}
.flagType:hover{
    border: 2px solid #8F4BE6;
}
#main{
    position: absolute;
    left: -8px;
    top: 0px;
    width: 400px;
    height: 260px;
    user-select: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    padding: 0px;
    margin: 0px;
    border-width: 0px;
}
.folder{
    background-color: #EAEDF2;
    width: 100%;
    // min-height: 100vh;
    // padding: 10px 50px;
    
    // position: fixed;
    display: flex;
    // width: 100%;
    // height: 100%;
}
.box{
    width: 100%;
    // margin: 20px 20px;
    padding: 30px 30px;
    background-color: white;
    // border-radius: 15px;
    .bg-purple{
        background-color: #EFEFEF;
        height: 230px;
        border-radius: 15px;
    }
    .cost{
        display: flex;
        align-items: start;
    }
}
</style>